import React from 'react';
import { useSpecSheetField } from '../../../../../queries/useSpecSheetField';
import { TextBox } from '@apply/components';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';

interface OtherProps {
    readOnly?: boolean;
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Other: React.FC<OtherProps> = ({ required, readOnly, propertyGuid, isReview = false }) => {
    const [other, setOther] = useSpecSheetField(
        propertyGuid,
        (s) => s.values?.['Interior Features']?.['Others'] ?? '',
        (s, v) => ({ ...s, values: { ...s.values, 'Interior Features': { ...s.values?.['Interior Features'], Others: v } } })
    );
    const label = 'Other';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={other}
                />
            ) : (
                <TextBox
                    value={other ?? ''}
                    onChange={(value) => setOther(value)}
                    label={label}
                    required={required}
                    readOnly={readOnly}
                />
            )}
        </>
    );
};
